/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M24.145 1.077l5.757 17.56L48 18.802 33.339 29.363l5.674 17.56-15.034-10.892L9.153 46.882l5.715-17.519L0 18.513l18.347.124 5.798-17.56z" fill-rule="nonzero"/>'
}
